import React from "react";
import styled from "styled-components";
import AuthForm from "../components/auth/AuthForm";

const cifLogoSrc = `${process.env.PUBLIC_URL ?? ""}/ciflogo.jpeg`;

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f0f4f8;
  padding: 24px;
`;

const StyledLogo = styled.img`
  height: 100px;
  width: 100px;
  object-fit: contain;
  display: block;
  margin-bottom: 24px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 28px;
  text-align: center;
  letter-spacing: -0.3px;
`;


const LoginPage: React.FC = () => {
  return (
    <PageContainer>
      <StyledLogo src={cifLogoSrc} alt="CIF Machine Hours" />
      <PageTitle>CiF Machine Performance Tracker</PageTitle>
      <AuthForm />
    </PageContainer>
  );
};

export default LoginPage;
